export default "__VITE_ASSET__DkcMXphb__"